const javaTimeFormat = 'YYYY-MM-DDTHH:mm:ss.000Z'
export default javaTimeFormat
